import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

const CircleDivider = ({
  className,
  width = '0.375rem',
  height = '0.375rem',
}: {
  className?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <Icon
      icon={faCircle}
      size="sm"
      style={{
        color: '#D9D9D9',
        width: width,
        height: height,
      }}
      className={className}
    />
  );
};

export default CircleDivider;
